import React, { createRef, useMemo, useState } from "react";
import Header from "../../component/header";
import Footer from "../../component/footer";
import Tab from "../../component/tab";
import Question from "./question";

// 轮播图图片引用（空白图片已补上）
let tabImge = [
  require("../../common/img/tab/img4.png"),
  require("../../common/img/tab/img1.png"),
  require("../../common/img/tab/img2.png"),
  require("../../common/img/tab/img3.png")
];

const defalutschema = {
  id: 1,
  desc: '课前测试题',
  totalScore: 0,
  question: [
    {
      id: 2,
      desc: '下列诗句中，“酒”所承载的情感与其他三项不同的是（ ）',
      the_score: 0,
      options: [
        {
          label: '李白《将进酒》：“人生得意须尽欢，莫使金樽空对月”',
          value: '李白《将进酒》：“人生得意须尽欢，莫使金樽空对月”',
          score: 1,
          selected: false
        },
        {
          label: '杜甫《登高》：“艰难苦恨繁霜鬓，潦倒新停浊酒杯”',
          value: '杜甫《登高》：“艰难苦恨繁霜鬓，潦倒新停浊酒杯”',
          score: 0,
          selected: false
        },
        {
          label: '王维《送元二使安西》：“劝君更尽一杯酒，西出阳关无故人”',
          value: '王维《送元二使安西》：“劝君更尽一杯酒，西出阳关无故人”',
          score: 0,
          selected: false
        },
        {
          label: '范仲淹《渔家傲·秋思》：“浊酒一杯家万里，燕然未勒归无计”',
          value: '范仲淹《渔家傲·秋思》：“浊酒一杯家万里，燕然未勒归无计”',
          score: 0,
          selected: false
        }
      ],
      selected: []
    }
  ]
};

// 初始化本地存储
window.localStorage.schema = JSON.stringify(defalutschema);
let a_schema;
try {
  a_schema = JSON.parse(window.localStorage.schema);
} catch {
  a_schema = defalutschema; // 解析失败用默认值兜底
}

// refs 数组声明（放在组件外，避免重复初始化）
let refs = [];

function Pretest() {
  // 状态声明（修复useState错误用法）
  const [show, setShow] = useState([-1, -1, -1]);
  const [schema] = useState(a_schema); // 去掉未使用的setSchema
  const [finish, setFinish] = useState(false);
  
  // 三个输入框分别声明状态（修复原来的对象解构错误）
  const [inputValue1, setInputValue1] = useState("");
  const [inputValue2, setInputValue2] = useState("");
  const [inputValue3, setInputValue3] = useState("");

  // 去掉未使用的变量声明
  let { question, desc } = schema;
  let totalScore;
  let newSchema = {
    id: 1,
    totalScore: 0,
    question: [],
  };

  const [btnDisabled, setBtnDisabled] = useState(false); 
  // 提交答案的处理函数
  const handleSave = () => {
    setBtnDisabled(true); 

    setFinish(true);
    totalScore = 0;

    // 获取选择题答案
    schema.question.forEach((item, index) => {
      if (refs[index] && refs[index].current) {
        const { getSchema } = refs[index].current;
        newSchema.question.push(getSchema());
        if (getSchema().the_score) {
          totalScore += getSchema().the_score;
        }
      }
    });

    // 判断填空题对错（修复直接修改原数组的问题）
    const newShow = [...show]; // 创建新数组，不直接修改原state
    if (inputValue1 === '一曲新词酒一杯') {
      totalScore += 1;
      newShow[0] = 1;
    } else {
      newShow[0] = 0;
    }

    if (inputValue2 === '把酒问青天') {
      totalScore += 1;
      newShow[1] = 1;
    } else {
      newShow[1] = 0;
    }

    if (inputValue3 === '莫笑农家腊酒浑') {
      totalScore += 1;
      newShow[2] = 1;
    } else {
      newShow[2] = 0;
    }
    setShow(newShow); // 统一更新state

    // 保存结果到本地存储并提示
    newSchema.totalScore = totalScore;
    window.localStorage.schema = JSON.stringify(newSchema);
    alert(`你本次答对${newSchema.totalScore}道题!\n1、答案：\n（1）一曲新词酒一杯\n（2）把酒问青天\n（3）莫笑农家腊酒浑\n2、解析：
  A 项（李白）：以酒扬志——借“金樽”抒发的是自信豪迈之情，即使失意仍保持狂放，酒是自我肯定、对抗命运的精神催化剂。
  B 项（杜甫）：以酒载愁——“浊酒”本是粗劣之酒，象征着诗人潦倒的境遇；“新停浊酒杯”更写出因重病不得不戒酒的无奈，酒成了欲饮不得、愁上加愁的情感载体。 
  C 项（王维）：以酒寄情——离别的酒，盛满对友人前路的不舍与牵挂，酒是连接人与人之间情感的纽带。
  D 项（范仲淹）：以酒怀远——边关将士的“浊酒”，装着的是万里之外的故乡与未竟的功业，酒是家国情怀的寄托。
      故选 A。`);
                                                                                                                              };

  // 初始化refs数组（保留学姐的ref功能）
  useMemo(() => {
    refs = question.map(item => createRef());
  }, [question]);

  // 输入框事件处理（修复直接赋值的问题）
  const changeInput1 = (e) => setInputValue1(e.target.value);
  const changeInput2 = (e) => setInputValue2(e.target.value);
  const changeInput3 = (e) => setInputValue3(e.target.value);

  // 显示对错图标
  const getTag = (index, showArr) => {
    if (showArr[index] === 0) {
      return <div className="cuoicon iconfont icon-cuo"></div>;
    } else if (showArr[index] === 1) {
      return <div className="duiicon iconfont icon-zhengque-correct"></div>;
    } else {
      return "";
    }
  };

  return (
    <div>
      <Header />
      <div className="page">
        {/* 轮播图（保留学姐的原始代码） */}
        <Tab
          className="banner"
          data={tabImge}
          renderItem={(item) => <img src={item} alt="轮播图" />}
        />
        <div className="page-con">
          <div className="problem">
            <div className="problem-inner">
              <p className="desc">{desc}</p>

              {/* 填空题部分（已更新为新题目） */}
              <div className="question">
                <p className="title1">1、补全诗句</p>
                <div className="wrapper">
                  (1)&nbsp;&nbsp;
                  <input type="text" className="question-input" onChange={changeInput1} />，去年天气旧亭台。
                  {getTag(0, show)}
                  <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——《浣溪沙》宋·晏殊
                </div>
                <div className="wrapper">
                  (2)&nbsp;&nbsp;明月几时有？
                  <input type="text" className="question-input" onChange={changeInput2} />。
                  {getTag(1, show)}
                  <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——《水调歌头·明月几时有》宋·苏轼
                </div>
                <div className="wrapper">
                  (3)&nbsp;&nbsp;
                  <input type="text" className="question-input" onChange={changeInput3} />，丰年留客足鸡豚。
                  {getTag(2, show)}
                  <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——《游山西村》宋·陆游
                </div>
              </div>

              {/* 选择题部分（保留原有组件逻辑，仅适配新题目） */}
              {schema.question.map((item, index) => (
                <div key={item.id} className="question">
                  <p className="title">{item.id}、{item.desc}</p>
                  <Question
                    finish={finish}
                    item={item}
                    ref={refs[index]}
                    yanz={[2, 1, 1, 1]}
                  />
                </div>
              ))}
            </div>
          </div>
          <button
            id="btn"
            disabled={btnDisabled}   // 绑定状态
            style={{                 // 可以简单设置样式，或用 CSS 类
              backgroundColor: btnDisabled ? 'gray' : '',
              cursor: btnDisabled ? 'default' : 'pointer',
              display: btnDisabled ? 'none' : 'inline-block'  // 如果真要隐藏
        }}
        onClick={handleSave}
          >
            提交
          </button>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Pretest;